"use client";

import {
  ProductCardList,
  ProductCardListSkeleton,
} from "@/features/product/components/ProductCardList";
import { useTranslations } from "@/i18n/client";
import { useWishlist } from "@/lib/centra/hooks";
import styles from "./index.module.css";

type WishlistProps = {
  isWishlistPage?: boolean;
};

export const Wishlist = ({ isWishlistPage }: WishlistProps) => {
  const { products, isLoading } = useWishlist();

  const t = useTranslations("myAccount.accountPage.tabs");
  return (
    <div className={styles.root}>
      {!!isWishlistPage && (
        <div className={styles.header}>
          <h2 className={styles.title}>{t("favourites")}</h2>
          {!products.length && !isLoading && (
            <p className={styles.emptyFavourites}>{t("emptyFavourites")}</p>
          )}
        </div>
      )}
      {isLoading && <ProductCardListSkeleton />}
      {products && <ProductCardList cards={products} />}
    </div>
  );
};

export const WishlistPreview = ({ limit = 4 }: { limit?: number }) => {
  const { products, isLoading } = useWishlist();
  const t = useTranslations("myAccount.accountPage.tabs");

  return (
    <div className={styles.root}>
      <h2 className={styles.sectionHeader}>{t("favourites")}</h2>
      <p className={styles.sectionSubHeader}>{t("lastAddedFavourites")}</p>
      {isLoading && <ProductCardListSkeleton />}
      {products && <ProductCardList cards={products.slice(0, limit)} />}
    </div>
  );
};
